import { hexToBytes, getEd25519 } from '@toruslabs/metadata-helpers';

const ed25519 = getEd25519();
function getED25519Key(privateKey) {
  const privKey = typeof privateKey === "string" ? hexToBytes(privateKey) : privateKey;
  const pk = ed25519.getPublicKey(privKey);
  const sk = new Uint8Array(64);
  sk.set(privKey, 0);
  sk.set(pk, 32);
  return {
    sk,
    pk
  };
}

export { getED25519Key };
